import React from 'react';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import './ChartPeriods.css';
class ChartPeriods extends React.Component {

  onYModeChanged() {
    var yModeZerobase = !this.state.yModeZerobase;
    if (this.props && this.props.onYModeChanged) {
      this.props.onYModeChanged(yModeZerobase ? "zerobase" : "standard");
    }
    this.setState({
      yModeZerobase,
    })
  }

  onChange(value) {
    if (this.props && this.props.onChange) {
      this.props.onChange(value);
    }
    this.setState({
      selectedPeriod:value
    })
  }

  componentWillMount() {
    var value = this.props && this.props.value ? this.props.value : "1Y";
    this.setState({
      selectedPeriod:value
    })
    var yModeZerobase = this.props && this.props.yModeZerobase && this.props.yModeZerobase != "standard" ? true : false;
    this.setState({
      yModeZerobase,
    })
  }

  render() {
    var value = this.state && this.state.selectedPeriod ? this.state.selectedPeriod : null;
    var yModeZerobase = this.state.yModeZerobase
    return(
      <div id="chartPeriodSelection">
        {value ?
          <div>
        <div className="periodButtons">
        <Button variant={value == "3M" ? "contained" : "outlined"} color={value == "3M" ? "primary" : "default"} onClick={() => this.onChange("3M")}>3M</Button>
        <Button variant={value == "6M" ? "contained" : "outlined"} color={value == "6M" ? "primary" : "default"} onClick={() => this.onChange("6M")}>6M</Button>
        <Button variant={value == "YTD" ? "contained" : "outlined"} color={value == "YTD" ? "primary" : "default"} onClick={() => this.onChange("YTD")}>YTD</Button>
        <Button variant={value == "1Y" ? "contained" : "outlined"} color={value == "1Y" ? "primary" : "default"} onClick={() => this.onChange("1Y")}>1Y</Button>
        <Button variant={value == "5Y" ? "contained" : "outlined"} color={value == "5Y" ? "primary" : "default"} onClick={() => this.onChange("5Y")}>5Y</Button>
        <Button variant={value == "10Y" ? "contained" : "outlined"} color={value == "10Y" ? "primary" : "default"} onClick={() => this.onChange("10Y")}>10Y</Button>
        <Button variant={value == "Max" ? "contained" : "outlined"} color={value == "Max" ? "primary" : "default"} onClick={() => this.onChange("Max")}>Max</Button>
        </div>
        <div class="zerobasecheckbox">
        <FormControlLabel
          control={<Checkbox defaultChecked color="primary" checked={yModeZerobase} onChange={() => this.onYModeChanged()}/>}
          label="Zero Based"
        />
        </div></div>
        :<div></div>}
      </div>
    );
  }
}
export default ChartPeriods;
